//#region IMPORTS
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { fetchInstoreTypesAsync } from "./instoreTypesSlice";
import { useEffect } from "react";
import InstoreTypesContainer from "../../components/instoreTypes/InstoreTypesContainer";
//#endregion

export default function InstoreTypesPage() {
  //#region SETUP
  const dispatch = useAppDispatch();
  const { instoreTypes_Loaded } = useAppSelector(
    ({ instoreTypes }) => instoreTypes
  );
  //#endregion

  //#region LOGIC
  useEffect(() => {
    const fetchOnload = async () => {
      if (!instoreTypes_Loaded) {
        await dispatch(fetchInstoreTypesAsync());
      }
    };
    fetchOnload();
  }, [instoreTypes_Loaded, dispatch]);
  //#endregion

  return <InstoreTypesContainer />;
}
